/* eslint-disable react/no-danger */
import React, { useState } from 'react'
import './Subtitle.css'

const Subtitle = ({ title, tooltip, tools }) => {
    const [expanded, setExpanded] = useState(false)
    const showTooltip = tooltip && expanded

    return (
        <div>
            <div className="sub-title flex ai-center jc-space-between">
                <div>{title}</div>
                {tooltip && (
                    <div
                        onClick={() => setExpanded(!expanded)}
                        className="toggle"
                    >
                        <i className="fa fa-question-circle-o " />
                    </div>
                )}
                {tools}
            </div>
            {showTooltip && <div className="alert alert-info">{tooltip}</div>}
        </div>
    )
}

export default Subtitle
